<div class="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-4 py-16 font-sans">

  <!-- Header -->
  <div class="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-600 shadow-sm">
    <lucide-icon name="zap" [size]="22" color="white" [strokeWidth]="2.5"></lucide-icon>
  </div>
  <h1 class="mt-5 text-2xl font-semibold text-slate-900">Choose your plan</h1>
  <p class="mt-2 text-sm text-slate-500">Pick a plan now — you can always change it later.</p>

  <!-- Error banner -->
  <div *ngIf="error" class="mt-6 flex w-full max-w-2xl items-start gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
    <lucide-icon name="triangle-alert" [size]="15" class="mt-0.5 flex-shrink-0 text-red-500" [strokeWidth]="2"></lucide-icon>
    <p class="text-sm text-red-700">{{ error }}</p>
  </div>

  <!-- Plan cards -->
  <div class="mt-8 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
    <div
      *ngFor="let plan of plans"
      class="relative flex flex-col rounded-2xl border bg-white px-6 py-7 shadow-sm transition-shadow hover:shadow-md"
      [class.border-violet-400]="plan.highlighted"
      [class.border-slate-200]="!plan.highlighted"
      [class.ring-2]="plan.highlighted"
      [class.ring-violet-200]="plan.highlighted"
    >
      <!-- "Most popular" badge -->
      <div
        *ngIf="plan.highlighted"
        class="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-violet-600 px-3 py-0.5 text-[11px] font-semibold text-white"
      >
        Most popular
      </div>

      <p class="text-sm font-semibold text-slate-900">{{ plan.name }}</p>
      <div class="mt-2 flex items-baseline gap-0.5">
        <span class="text-3xl font-bold text-slate-900">{{ plan.price }}</span>
        <span class="text-sm text-slate-400">{{ plan.period }}</span>
      </div>
      <p class="mt-2 text-xs text-slate-500">{{ plan.description }}</p>

      <ul class="mt-5 flex-1 space-y-2">
        <li *ngFor="let feature of plan.features" class="flex items-center gap-2 text-xs text-slate-700">
          <lucide-icon name="circle-check" [size]="14" class="flex-shrink-0 text-violet-500" [strokeWidth]="2"></lucide-icon>
          {{ feature }}
        </li>
      </ul>

      <button
        (click)="selectPlan(plan.tier)"
        [disabled]="loading"
        class="mt-7 flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
        [class.bg-violet-600]="plan.highlighted"
        [class.text-white]="plan.highlighted"
        [class.hover:bg-violet-700]="plan.highlighted"
        [class.focus:ring-violet-500]="plan.highlighted"
        [class.bg-slate-100]="!plan.highlighted"
        [class.text-slate-800]="!plan.highlighted"
        [class.hover:bg-slate-200]="!plan.highlighted"
        [class.focus:ring-slate-400]="!plan.highlighted"
      >
        <lucide-icon
          *ngIf="activatingTier === plan.tier"
          name="loader"
          [size]="15"
          class="animate-spin"
          [strokeWidth]="2.5"
        ></lucide-icon>
        {{ activatingTier === plan.tier ? 'Activating...' : 'Get started' }}
      </button>
    </div>
  </div>

  <p class="mt-8 text-xs text-slate-400">No payment required. Change plans any time from settings.</p>
</div>
